export const HANDSONTABLE_LICENSE = '0055e-94fe7-37163-1412c-5623e';
export const MUI_LICENSE = 'd0597a7f3f15c57939af7e67a5f2903cTz0xMDAyMzIsRT0xNzYwODMzNDc2MDAwLFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1RMy0yMDI0LEtWPTI=';
//# sourceMappingURL=constants.js.map